import styled from 'styled-components';
export const ScrollButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  width: 40px;
  height: 40px;

  background: #fff;
  border: 1px solid black;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 3;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease;
  margin: 0;

  @media (hover: hover) {
    &:hover {
      background: #e0e0e0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      svg path {
        fill: #555555;
      }
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.left {
    left: 3px;
  }

  &.right {
    right: 3px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const QuestionsWrapper = styled.div<{ leftGradient: boolean; rightGradient: boolean }>`
  position: relative;
  overflow: hidden;

  /* Gradient overlays for desktop */
  @media (min-width: 769px) {
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 70px;
      z-index: 2;
      pointer-events: none; /* Allow clicks to pass through */
      opacity: 0;
      transition: all 0.2s ease;
    }

    &::before {
      left: 0;
      background: linear-gradient(to right, white, rgba(255, 255, 255, 0));
    }
    ${({ leftGradient }) => leftGradient && '&::before { opacity: 1; } '}

    &::after {
      right: 0;
      background: linear-gradient(to left, white, rgba(255, 255, 255, 0));
    }
    ${({ rightGradient }) => rightGradient && '&::after { opacity: 1; }'}
  }
`;

export const SampleQuestionsContainer = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 6px 12px 14px 12px;

  max-height: ${(props) => (props.isOpen ? '200px' : '0px')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  overflow: hidden;
  transition:
    max-height 0.4s ease,
    opacity 0.3s ease;
`;

export const SampleQuestionsTitle = styled.div`
  font-family: Lato;
  font-weight: 700;
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
`;

export const SAMPLE_QUESTIONS_BUTTON_WIDTH_PX = 238;
export const SAMPLE_QUESTIONS_GAP_BETWEEN_BUTTONS_PX = 10;

export const SampleQuestionsButtonsContainer = styled.div`
  display: flex;

  gap: ${SAMPLE_QUESTIONS_GAP_BETWEEN_BUTTONS_PX}px;
  position: relative;
  z-index: 1;
  padding: 0 60px;
  margin: 0 -60px;
  width: calc(100% + 118px);

  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  overscroll-behavior-y: none;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-padding: 0 calc(50% - ${SAMPLE_QUESTIONS_BUTTON_WIDTH_PX / 2});
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &.enable-wheel {
    scroll-behavior: smooth;
  }

  &.has-overflow::after {
    opacity: 1;
  }
`;

export const SampleQuestionsButton = styled.button`
  border: none;
  flex: 0 0 auto;
  background: #000;
  color: #fff;
  border-radius: 12px;
  padding: 1rem;
  width: ${SAMPLE_QUESTIONS_BUTTON_WIDTH_PX}px;
  max-width: 70%;
  scroll-snap-align: center;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    opacity 0.3s ease;

  font-family: Lato;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0px;

  @media (min-width: 769px) {
    &:hover {
      background: #333;
    }
  }

  &:focus {
    outline: none;
  }
`;
